import React, { useState } from 'react';
import styles from './app.module.scss';
import { Grid, Drawer, Box, IconButton, Hidden } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import CodeIcon from '@material-ui/icons/Code';
import PeopleIcon from '@material-ui/icons/People';
import ComputerIcon from '@material-ui/icons/Computer';
import BuildIcon from '@material-ui/icons/Build';
import ProjectCard from './components/project-card/project-card';
import { projects } from './constants/project-config';
import ScrollToTop from "react-scroll-to-top";


function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <React.Fragment>
      <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)} classes={{ paper: styles.menuContent }}>
        <Grid container>
          <Grid item xs={12}>
            <Box textAlign="right">
              <IconButton aria-label="close side menu" onClick={() => setMenuOpen(false)} className={styles.menuCloseBtn}>
                <CloseIcon fontSize="large" />
              </IconButton>
            </Box>
            <Box textAlign="center" pt={3}>
              <nav>
                <ul>
                  <li><a href="#competencies">Competencies</a></li>
                  <li><a href="#portfolio">Portfolio</a></li>
                  <li><a href="#about">About</a></li>
                </ul>
              </nav>
            </Box>
          </Grid>
        </Grid>
      </Drawer>
      <div className={`containerWrapper ${styles.app}`}>
        <ScrollToTop smooth color="green"/>
        <Grid container>
          <Grid item xs={12}>
            <header className={styles.header}>
              <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <h1>EK</h1>
                </Grid>
                <Hidden mdDown>
                  <Grid item className={styles.navbarContent}>
                    <nav>
                      <ul>
                        <li><a href="#competencies">Competencies</a></li>
                        <li><a href="#portfolio">Portfolio</a></li>
                        <li><a href="#about">About</a></li>
                      </ul>
                    </nav>
                  </Grid>
                </Hidden>
                <Hidden lgUp>
                  <Grid item>
                    <IconButton aria-label="menu" className={styles.menuIcon} onClick={() => setMenuOpen(true)}>
                      <MenuIcon fonstSize="large" />
                    </IconButton>
                  </Grid>
                </Hidden>
              </Grid>
            </header>
          </Grid>
          <Grid item xs={12} className={styles.intro}>
            <div className={styles.introContent}>
              <h1>EMMA KLEIN</h1>
              <h3>Front End Developer & Team Lead</h3>
              <Grid container justify="center" alignItems="center">
                <Grid item className={styles.hireMe}>
                    <a href="http://www.github.com/kleinemmac" target="_blank" rel="noreferrer noopener"><GitHubIcon /></a>
                </Grid>
                <Grid item className={styles.hireMe}>
                  <a href="http://www.linkedin.com/in/emma-klein46028a1a5" target="_blank" rel="noreferrer noopener"><LinkedInIcon /></a>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} className={styles.competencies} id="competencies">
            <h2>COMPETENCIES</h2>
            <Grid container>
              <Grid item xs={12} md={3}>
                <ComputerIcon />
                <h3>Tools of the Trade</h3>
                <ul>
                  <li>Agile/SCRUM practices</li>
                  <li>Jira/Trello/Kanban</li>
                  <li>Adobe XD/Photoshop</li>
                  <li>Terminal/Git</li>
                  <li>Management/Customer Service</li>
                  <li>Technical Writing/Editing</li>
                </ul>
              </Grid>
              <Grid item xs={12} md={3}>
                <CodeIcon />
                <h3>Programming Languages</h3>
                <ul>
                  <li>HTML</li>
                  <li>CSS</li>
                  <li>SASS</li>
                  <li>Javascript/ES6+</li>
                </ul>
              </Grid>
              <Grid item xs={12} md={3}>
                <BuildIcon />
                <h3>Frameworks and Libraries</h3>
                <ul>
                  <li>ReactJS/Redux/React Router</li>
                  <li>VueJS/Vuex/Vue Router</li>
                  <li>jQuery</li>
                  <li>Material-UI/Vuetify</li>
                  <li>Bootstrap</li>
                </ul>
              </Grid>
              <Grid item xs={12} md={3}>
                <PeopleIcon />
                <h3>Soft Skills</h3>
                <ul>
                  <li>Collaboration</li>
                  <li>Organization</li>
                  <li>Leadership</li>
                  <li>Empathy</li>
                  <li>Creativity</li>
                  <li>Critical Thinking</li>
                  <li>Adaptability</li>
                </ul>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={styles.portfolio} id="portfolio">
            <h2>PORTFOLIO</h2>
            <Grid container justify="center" spacing={3} className={styles.cardContainer}>
              { projects.map(project => {
                  return (
                    <Grid item xs={12} md={4} lg={4} key={project.title}>
                      <ProjectCard project={project} />
                    </Grid>
                  )
                })
              }
            </Grid>
          </Grid>
          <Grid item xs={12} className={styles.about} id="about">
            <h2>ABOUT ME</h2>
            <p>
            Shortly after sunrise one brisk winter morning, I found myself peeling a feral cat off of my face at my local animal shelter and 
            wondering if there were any career paths that involved slightly less blood loss and some bearable form of discomfort. Turns out 
            Frontend Development has almost a 0% rabies risk and it ended up being a good fit for me.
            </p>
            <p>
              I am a Front End Developer currently serving as a Team Lead & Principal Front End Developer at Queen's Web. Rather than sticking 
              solely to Front End development, I have dedicated my time to gaining proficiency in other intricacies of web development in order 
              to hone my skills as a developer, problem solver, and leader.
            </p>
            <p>
              I create clean, functional, responsive websites and applications and I am competent in Front End & UI/UX principles to the degree that 
              I can deliver high quality final products confidently.
            </p>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}

export default App;
